import { FC } from "react";

interface CircleTickFillProps {
  fill?: string
}

const CircleTickFill: FC<CircleTickFillProps> = ({fill = '#000000'}) => {
    return (
        <>
            <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="10" fill="#167E76" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16.3683 9.13327C16.5445 9.31036 16.5438 9.59679 16.3667 9.77303L10.4575 15.654C10.281 15.8296 9.99577 15.8296 9.81928 15.654L7.13327 12.9808C6.95618 12.8046 6.95549 12.5181 7.13173 12.3411C7.30798 12.164 7.59441 12.1633 7.77149 12.3395L10.1384 14.6951L15.7285 9.13173C15.9056 8.95549 16.192 8.95618 16.3683 9.13327Z"
              fill="white"
              stroke="white"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </>
    )
}

export default CircleTickFill;